/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Area Restrita API
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  CreateDocumentCategoryCommandBody,
  CreateDocumentCategoryCommandResponse,
  DocumentCategoryQueryResponse,
  GetDocumentCategoriesParams,
  UpdateDocumentCategoryCommandBody,
  UpdateDocumentCategoryCommandResponse
} from '../../model';

import { instance } from '../../index';
import type { ErrorType, BodyType } from '../../index';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getDocumentCategories = (
    params: GetDocumentCategoriesParams,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<DocumentCategoryQueryResponse>(
      {url: `/api/v1/document-category`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetDocumentCategoriesQueryKey = (params: GetDocumentCategoriesParams,) => {
    return [`/api/v1/document-category`, ...(params ? [params]: [])] as const;
    }

    
export const getGetDocumentCategoriesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getDocumentCategories>>, GetDocumentCategoriesParams['page']>, TError = ErrorType<unknown>>(params: GetDocumentCategoriesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDocumentCategories>>, TError, TData, Awaited<ReturnType<typeof getDocumentCategories>>, QueryKey, GetDocumentCategoriesParams['page']>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentCategoriesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentCategories>>, QueryKey, GetDocumentCategoriesParams['page']> = ({ signal, pageParam }) => getDocumentCategories({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDocumentCategories>>, TError, TData, Awaited<ReturnType<typeof getDocumentCategories>>, QueryKey, GetDocumentCategoriesParams['page']> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDocumentCategoriesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getDocumentCategories>>>
export type GetDocumentCategoriesInfiniteQueryError = ErrorType<unknown>


export function useGetDocumentCategoriesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDocumentCategories>>, GetDocumentCategoriesParams['page']>, TError = ErrorType<unknown>>(
 params: GetDocumentCategoriesParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDocumentCategories>>, TError, TData, Awaited<ReturnType<typeof getDocumentCategories>>, QueryKey, GetDocumentCategoriesParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentCategories>>,
          TError,
          Awaited<ReturnType<typeof getDocumentCategories>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentCategoriesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDocumentCategories>>, GetDocumentCategoriesParams['page']>, TError = ErrorType<unknown>>(
 params: GetDocumentCategoriesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDocumentCategories>>, TError, TData, Awaited<ReturnType<typeof getDocumentCategories>>, QueryKey, GetDocumentCategoriesParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentCategories>>,
          TError,
          Awaited<ReturnType<typeof getDocumentCategories>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentCategoriesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDocumentCategories>>, GetDocumentCategoriesParams['page']>, TError = ErrorType<unknown>>(
 params: GetDocumentCategoriesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDocumentCategories>>, TError, TData, Awaited<ReturnType<typeof getDocumentCategories>>, QueryKey, GetDocumentCategoriesParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetDocumentCategoriesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDocumentCategories>>, GetDocumentCategoriesParams['page']>, TError = ErrorType<unknown>>(
 params: GetDocumentCategoriesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDocumentCategories>>, TError, TData, Awaited<ReturnType<typeof getDocumentCategories>>, QueryKey, GetDocumentCategoriesParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDocumentCategoriesInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetDocumentCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof getDocumentCategories>>, TError = ErrorType<unknown>>(params: GetDocumentCategoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentCategories>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentCategoriesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentCategories>>> = ({ signal }) => getDocumentCategories(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDocumentCategories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDocumentCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof getDocumentCategories>>>
export type GetDocumentCategoriesQueryError = ErrorType<unknown>


export function useGetDocumentCategories<TData = Awaited<ReturnType<typeof getDocumentCategories>>, TError = ErrorType<unknown>>(
 params: GetDocumentCategoriesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentCategories>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentCategories>>,
          TError,
          Awaited<ReturnType<typeof getDocumentCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentCategories<TData = Awaited<ReturnType<typeof getDocumentCategories>>, TError = ErrorType<unknown>>(
 params: GetDocumentCategoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentCategories>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentCategories>>,
          TError,
          Awaited<ReturnType<typeof getDocumentCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentCategories<TData = Awaited<ReturnType<typeof getDocumentCategories>>, TError = ErrorType<unknown>>(
 params: GetDocumentCategoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentCategories>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetDocumentCategories<TData = Awaited<ReturnType<typeof getDocumentCategories>>, TError = ErrorType<unknown>>(
 params: GetDocumentCategoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentCategories>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDocumentCategoriesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetDocumentCategoriesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getDocumentCategories>>, TError = ErrorType<unknown>>(params: GetDocumentCategoriesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocumentCategories>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentCategoriesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentCategories>>> = ({ signal }) => getDocumentCategories(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocumentCategories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDocumentCategoriesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getDocumentCategories>>>
export type GetDocumentCategoriesSuspenseQueryError = ErrorType<unknown>


export function useGetDocumentCategoriesSuspense<TData = Awaited<ReturnType<typeof getDocumentCategories>>, TError = ErrorType<unknown>>(
 params: GetDocumentCategoriesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocumentCategories>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentCategoriesSuspense<TData = Awaited<ReturnType<typeof getDocumentCategories>>, TError = ErrorType<unknown>>(
 params: GetDocumentCategoriesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocumentCategories>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentCategoriesSuspense<TData = Awaited<ReturnType<typeof getDocumentCategories>>, TError = ErrorType<unknown>>(
 params: GetDocumentCategoriesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocumentCategories>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetDocumentCategoriesSuspense<TData = Awaited<ReturnType<typeof getDocumentCategories>>, TError = ErrorType<unknown>>(
 params: GetDocumentCategoriesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDocumentCategories>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDocumentCategoriesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const createDocumentCategory = (
    createDocumentCategoryCommandBody: BodyType<CreateDocumentCategoryCommandBody>,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<CreateDocumentCategoryCommandResponse>(
      {url: `/api/v1/document-category`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createDocumentCategoryCommandBody, signal
    },
      options);
    }
  


export const getCreateDocumentCategoryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDocumentCategory>>, TError,{data: BodyType<CreateDocumentCategoryCommandBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof createDocumentCategory>>, TError,{data: BodyType<CreateDocumentCategoryCommandBody>}, TContext> => {
    
const mutationKey = ['createDocumentCategory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDocumentCategory>>, {data: BodyType<CreateDocumentCategoryCommandBody>}> = (props) => {
          const {data} = props ?? {};

          return  createDocumentCategory(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateDocumentCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof createDocumentCategory>>>
    export type CreateDocumentCategoryMutationBody = BodyType<CreateDocumentCategoryCommandBody>
    export type CreateDocumentCategoryMutationError = ErrorType<unknown>

    export const useCreateDocumentCategory = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDocumentCategory>>, TError,{data: BodyType<CreateDocumentCategoryCommandBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof createDocumentCategory>>,
        TError,
        {data: BodyType<CreateDocumentCategoryCommandBody>},
        TContext
      > => {

      const mutationOptions = getCreateDocumentCategoryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const updateDocumentCategory = (
    id: number,
    updateDocumentCategoryCommandBody: BodyType<UpdateDocumentCategoryCommandBody>,
 options?: SecondParameter<typeof instance>,) => {
      
      
      return instance<UpdateDocumentCategoryCommandResponse>(
      {url: `/api/v1/document-category/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateDocumentCategoryCommandBody
    },
      options);
    }
  


export const getUpdateDocumentCategoryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDocumentCategory>>, TError,{id: number;data: BodyType<UpdateDocumentCategoryCommandBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDocumentCategory>>, TError,{id: number;data: BodyType<UpdateDocumentCategoryCommandBody>}, TContext> => {
    
const mutationKey = ['updateDocumentCategory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDocumentCategory>>, {id: number;data: BodyType<UpdateDocumentCategoryCommandBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateDocumentCategory(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateDocumentCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof updateDocumentCategory>>>
    export type UpdateDocumentCategoryMutationBody = BodyType<UpdateDocumentCategoryCommandBody>
    export type UpdateDocumentCategoryMutationError = ErrorType<unknown>

    export const useUpdateDocumentCategory = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDocumentCategory>>, TError,{id: number;data: BodyType<UpdateDocumentCategoryCommandBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateDocumentCategory>>,
        TError,
        {id: number;data: BodyType<UpdateDocumentCategoryCommandBody>},
        TContext
      > => {

      const mutationOptions = getUpdateDocumentCategoryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    